<template>
  <div>
    <PodRoomListSwiperView
     v-for="roomTypeMeta in roomTypeSet"
     :key="roomTypeMeta.slug"
     :roomTypeMeta="roomTypeMeta"
    />

    <PodRoomMessageModal />
  </div>
</template>

<script>
import PodRoomListSwiperView from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodRoomListSwiperView/PodRoomListSwiperView.vue'
import PodRoomMessageModal   from '@/components/Pages/Connections/ConnectionApp/components/PodRoomMessageModal/PodRoomMessageModal.vue'

export default {
  components : {
    PodRoomListSwiperView,
    PodRoomMessageModal
  },

  data(){
    return {
      roomTypeSet : [
        {
          slug  : 'public',
          title : '様々',
        },
        {
          slug  : 'private',
          title : 'マイポット',
        },
      ]
    };
  }
}
</script>